import React from 'react';
import { ErrorContentLayout } from 'layout';
import { useDossierContext } from 'common-app/dossier';
export const DossierErrorScene = () => {
    const { dossier } = useDossierContext();
    return (React.createElement(ErrorContentLayout, null, dossier === null || dossier === void 0 ? void 0 : dossier.error));
};
